import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer-section py-3">
      <div className="container">
        <div className="footer-links mb-3">
          <Link to="/disclaimer" className="footer-link">
            Disclaimer
          </Link>
          <span className="divider">|</span>
          <Link to="/privacy-policy" className="footer-link">
            Privacy Policy
          </Link>
          <span className="divider">|</span>
          <Link to="/terms" className="footer-link">
            Terms of Service
          </Link>
        </div>
        <div className="col-12 text-center">
          <p className="copyright">
            © 2025 HealthWiibes. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;